import { Link } from "react-router-dom";

export default function HomeDocuments() {
    return (
        <div>
            <div>
                <Link to="listado">
                    Lista Remitos Out
                </Link>
            </div>
            <div>
                <Link to="create">
                    Nuevo Remito Out
                </Link>
            </div>
            <div>
                <Link to="/inDocument">
                    Lista Remitos In
                </Link>
            </div>
            <div>
                <Link to="/inDocument/create">
                    Nuevo Remito In
                </Link>
            </div>
        </div>
    )
}